/**
 * Resolves the Postgres schema the Learning Diversity clients talk to
 * (`learning_diversity` on SCR Central).
 *
 * Fails closed. On the shared database a bare table name resolves to `public`,
 * which belongs to other applications and still answers successfully, so an
 * unset or `public` value must never be silently accepted.
 *
 * The cast to `'public'` is only for the untyped Supabase client, whose `db.schema`
 * option is otherwise narrowed to the literal `'public'`.
 */
export function requireAppSchema(value: string | undefined, varName: string): 'public' {
  const schema = (value ?? '').trim();
  if (!schema || schema === 'public') {
    throw new Error(`${varName} must be set to the app schema`);
  }
  return schema as 'public';
}
